import { CookieSet, CookieState } from "../types/campaignTypes";

export function getCookieStrings(cookieSets: CookieState) {
  const cookieStrings: Array<number> = [];

  for (const key in cookieSets) {
    if (cookieSets[key]) {
      if (typeof cookieSets[key] === "string" || key.includes("_ALL")) {
        // eslint-disable-next-line no-continue
        continue;
      }

      cookieSets[key].forEach((cookie: CookieSet) => {
        cookieStrings.push(cookie.adLibId);
      });
    }
  }

  return cookieStrings;
}
